"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeHxMonthlyAbsolutePattern = exports.deserializeHxMonthlyAbsolutePattern = void 0;
function deserializeHxMonthlyAbsolutePattern(values) {
    if (values.length !== 3) {
        throw new Error('Found ' + values.length + ' prop in HxMonthlyAbsolutePattern');
    }
    var interval = values[0];
    var dayOfMonth = values[1];
    var calendarType = values[2];
    return { interval: interval, dayOfMonth: dayOfMonth, calendarType: calendarType };
}
exports.deserializeHxMonthlyAbsolutePattern = deserializeHxMonthlyAbsolutePattern;
function serializeHxMonthlyAbsolutePattern(arg) {
    var output = [];
    output.push(arg.interval);
    output.push(arg.dayOfMonth);
    output.push(arg.calendarType);
    return output;
}
exports.serializeHxMonthlyAbsolutePattern = serializeHxMonthlyAbsolutePattern;
